import { Dialog, DialogContent, DialogTitle } from "./dialog";
import { useAccount, useBalance, useWalletClient } from "wagmi";
import { abiToken } from "./erc20";

import { abi } from "./contract";
import { ethers } from "ethers";
import React, { useEffect, useState } from "react";

import {
  useContractWrite,
  usePrepareContractWrite,
  useContractRead,
} from "wagmi";
import TokenAvatar from "./shared/TokenAvatar";
import { Token } from "../types/Token";
import { BSCtoken } from "../config/TokenList";
import { Input } from "./shared/Input";
import useCurrentChain from "../hooks/useCurrentChain";

type PropTypes = {
  open: boolean;
  onClose: () => void;
};

const Stake: React.FC<PropTypes> = ({ open, onClose }) => {
  const [selectedOption, setSelectedOption] = useState<number>(30);
  const [decimals, setDecimals] = useState(18);
  const [allawee, setAllawee] = useState(0);
  const { address } = useAccount();
  const chain = useCurrentChain();
  const balance = useBalance({ address, chainId: chain.id! });
  const [amount, setAmount] = useState(0);
  const { data: walletClient } = useWalletClient();
  //toggleToken
  const [token] = useState<Token>(BSCtoken!);

  const { data: tokenDecimals } = useContractRead({
    address: `0x${process.env.REACT_APP_TOKEN_ADDRESS}`,
    abi: abiToken,
    functionName: "decimals",
    watch: true,
  });

  useEffect(() => {
    if (tokenDecimals) {
      setDecimals(Number(tokenDecimals));
    }
  }, [tokenDecimals]);

  let amountToStake;
  if (amount) {
    amountToStake = ethers.parseUnits(amount!.toString(), decimals);
  }

  const { config: approveConfig } = usePrepareContractWrite({
    address: `0x${process.env.REACT_APP_TOKEN_ADDRESS}`,
    abi: abiToken,
    functionName: "approve",
    args: [`0x${process.env.REACT_APP_STAKING_ADDRESS}`, amountToStake],
  });

  // Execute the approval transaction
  const { write: approveWrite } = useContractWrite(approveConfig);

  // Calculate the vesting period in seconds
  const vestingPeriodInSeconds = selectedOption * 24 * 60 * 60;

  //check allowance
  const { data: allowance } = useContractRead({
    address: `0x${process.env.REACT_APP_TOKEN_ADDRESS}`,
    abi: abiToken,
    functionName: "allowance",
    args: [address, `0x${process.env.REACT_APP_STAKING_ADDRESS!}`],
  });

  useEffect(() => {
    if (allowance) {
      setAllawee(Number(allowance));
    }
  }, [allowance]);
  // Calculate the amount to stake

  // Function to handle staking
  const handleStake = async () => {
    if (!amount || !address || !walletClient) return;
    if (!amount || !address) return;
    const amountToStake = ethers.parseUnits(amount!.toString(), decimals);
    // User-defined amount to stake
    if (allowance && allawee < amountToStake) {
      approveWrite!();
    } else {
      // If already approved for the amount, directly stake
      stake!();
    }
  };

  const { config: stakeConfig } = usePrepareContractWrite({
    address: `0x${process.env.REACT_APP_STAKING_ADDRESS}`,
    abi,
    functionName: "stake",
    args: [amountToStake, vestingPeriodInSeconds],
  });

  const { isLoading, write: stake } = useContractWrite(stakeConfig);

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="border-none justify-center items-center text-center p-8  bg-black/90 text-white">
        <DialogTitle className="text-white text-2xl">BUY AND STAKE</DialogTitle>
        <div className="flex gap-4 justify-between items-center px-4">
          <hr className="border-gray-300 w-[15%]" />
          <p>
            {token.symbol} balance{" "}
            {balance?.data?.formatted?.toString().substring(0, 6) ?? 0}
          </p>
          <hr className="border-gray-300 w-[15%]" />
        </div>
        <div className="flex flex-col justify-stretch content-center items-start">
          <div className="flex flex-row self-stretch justify-between">
            <p>{token.symbol} you pay</p>
            <button
              className="bg-transparent text-white text-sm"
              onClick={() => setAmount(Number(balance?.data?.formatted ?? 0))}
            >
              Max
            </button>
          </div>
          <div className="flex w-full justify-center  border items-center border-gray-300 rounded-md">
            <Input
              type="number"
              min={1}
              value={amount}
              onChange={(e) => setAmount(Number(e.target.value))}
              className="text-white border-gray-300 rounded-md p-2 bg-transparent placeholder-gray-300"
              placeholder="0"
            />
            <TokenAvatar
              className="mx-1"
              symbol={token.symbol}
              logo={token.logoURI!}
              size={24}
            />
          </div>
        </div>
        <select
          value={selectedOption}
          onChange={(e) => setSelectedOption(Number(e.target.value))}
          className="border text-white text-md bg-transparent border-gray-300 rounded-md p-2 py-4"
        >
          <option className="bg-black/90 text-whtie " value="30">
            30 days
          </option>
          <option className="bg-black/90 text-whtie" value="60">
            60 days
          </option>
          <option className="bg-black/90 text-whtie" value="90">
            90 days
          </option>
          <option className="bg-black/90 text-whtie" value="120">
            120 days
          </option>
        </select>
        <button
          className="text-center text-white border-[2px] border-[#ffd400] rounded-3xl p-3 w-full"
          disabled={isLoading}
          onClick={() => handleStake()}
        >
          {isLoading ? "Stacking..." : "BUY AND STAKE FOR % REWARDS"}
        </button>
      </DialogContent>
    </Dialog>
  );
};

export default Stake;
